import { useLayoutEffect } from "react";

export const useSetBgOnBody = ({ bg }: { bg: string | undefined }) => {
  useLayoutEffect(() => {
    if (!bg) {
      return;
    }

    document.body.style.setProperty("--page-bg", bg);
    return () => {
      document.body.style.removeProperty("--page-bg");
    };
  }, [bg]);
};
